import { Injectable, OnInit, ElementRef } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { loadModules } from "esri-loader";
import esri = __esri;


/* THIS SERVICE IS A ONE OFF - DIFFERENT FROM THE REGULAR ODNR-MAP IN THAT
    IT NEEDS TO QUERY EACH LAYER OF THE OHIO GIS PROVIDERS LAYERS TO RETRIEVE DATA,
    IT'S ONLY AVAILABLE IN 2D AND THERE ARE NO WIDGETS. IT ALSO PROVIDES EXTRA FUNCTIONALITY


    AND FINALLY - NO AUTHENTICATION IS NEEDED FOR THIS SERVICE
 */

@Injectable()
export class WellViewerService {
    // MAP ELEMENTS
    // 2D Basemap type
    public _2dBasemap: string = "topo";
    // 2D map
    _2dMap: esri.Map;
    // 2D map properties
    _2dMapProperties: esri.MapProperties;
    // VIEW ELEMENTS
    // 2D View
    mapView: esri.MapView;
    // 2D MapView properties
    mapViewProperties: esri.MapViewProperties;

    // Observable list of layers for the legend
    layerList = new BehaviorSubject(Array({}));
    layerList$ = this.layerList.asObservable();
    clearLayerList(): void {
        this.layerList.next([]);
    }
    addToLayerList(data: any): void {
        let tempArray = this.layerList.getValue();
        tempArray.push(data);
        this.layerList.next(tempArray);
    }
    updateLayerList(data: any): void {
        this.layerList.next(data);
    }


    public async initialize2dView(wellViewerNode: ElementRef): Promise<void> {
        if (wellViewerNode) {
            try {
                const [EsriMap, MapView, WatchUtils] = await loadModules([
                    "esri/Map",
                    "esri/views/MapView",
                    "esri/core/watchUtils"
                ]);

                // Setup map properties
                this._2dMapProperties = {
                    basemap: this._2dBasemap,
                    ground: "world-elevation"
                };
                this._2dMap = new EsriMap(this._2dMapProperties);

                this.mapViewProperties = {
                    container: wellViewerNode.nativeElement,
                    center: [-82.681348, 40.204603],
                    zoom: 8,
                    map: this._2dMap,
                    constraints: {
                        snapToZoom: false,
                        rotationEnabled: false
                    }
                };
                this.mapView = new MapView(this.mapViewProperties);
                this.mapView.ui.components = ["attribution"];

                this.mapView.when(() => {
                    this.checkGenerateLegend();

                    this.mapView.watch("extent", () => {
                        let tempArray = [];

                        (this._2dMap.layers as any).items.forEach(f => {
                            // Find the existing to get visible
                            const foundLayer = this.layerList.getValue().find(x => (x as any).id === f.id);

                            tempArray.push({ "id": f.id, "title": f.title, "visible": (foundLayer as any).visible, "enabled": (f.minScale === 0 || f.minScale > this.mapView.scale) });
                        });

                        // Sort alpha by title
                        tempArray.sort((a, b) => {
                            return (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0);
                        });
                        this.clearLayerList();
                        this.updateLayerList(tempArray);

                    });

                    // Popup Configuration
                    this.mapView.on("click",
                        (event) => {
                            this.mapView.hitTest(event).then(response => {
                                const feature = response.results[0].graphic;
                                this.QueryObject(feature.getAttribute("OBJECTID"),
                                    (feature as any).sourceLayer.parsedUrl.path).then(popupContent => {
                                        // console.log("popup content----->", popupContent);
                                        this.mapView.popup.open({
                                            title: feature.layer.title || "",
                                            content: this.parsePopupContent(popupContent),
                                            location: event.mapPoint
                                        });
                                    });
                            });
                        });
                });
            } catch (error) {
                console.log(`We have an error: ${error}`);
            }
        }
    }

    async loadFeatureLayer(gisServiceUrl: string, layerVisible: boolean): Promise<any> {
        var error;
        try {
            const [FeatureLayer, esriRequest] = await loadModules([
                "esri/layers/FeatureLayer",
                "esri/request"
            ]);
            return new Promise((resolve, reject) => {
                const formattedMapServerUrl = gisServiceUrl + "?f=json";
                esriRequest(formattedMapServerUrl).then(results => {
                    results.data.layers.forEach(async layer => {
                        const layerUrl = gisServiceUrl + "/" + layer.id.toString();
                        const tempFeatureLayer = new FeatureLayer({
                            url: layerUrl
                            //popupTemplate: {
                            //    title: "TESTING",
                            //    content:"Test content"
                            //}
                        });
                        this._2dMap.add(tempFeatureLayer);
                        tempFeatureLayer.visible = layerVisible;
                        resolve(tempFeatureLayer);
                    });
                });
            });
        } catch (error) {
            console.log(`We have an error: ${error}`);
        }
    }
    
    public async QueryObject(objectID: string, featureLayerUrl: string): Promise<any> {
        var error;
        try {
            const [Query, QueryTask, esriRequest] = await loadModules([
                "esri/tasks/support/Query",
                "esri/tasks/QueryTask",
                "esri/request"
            ]);
            return new Promise((resolve, reject) => {
                let formattedMapServerUrl = featureLayerUrl + "?f=json";
                //esriRequest(formattedMapServerUrl).then(results => {
                //results.data.layers.forEach(async layer => {
                // Sub layers????
                const testQueryTask = new QueryTask({
                    url: featureLayerUrl
                });
                let query = new Query();

                query.where = "OBJECTID=" + objectID;
                query.returnGeometry = false;
                query.outFields = ["*"];
                // Query only for this extent
                //query.geometry = extent;
                testQueryTask.execute(query).then(result => {
                    if (result.features && result.features.length > 0) {
                        resolve(result.features[0].attributes);
                    }
                });
                //});
                //});
            });
        } catch (error) {
            console.log(`We have an error: ${error}`);
        }
    }

    // Timer function to ensure all layers are loaded
    public checkGenerateLegend(): void {
        let check = this._2dMap.allLayers.find(l => l.loaded === false);
        if (!check && this._2dMap.allLayers.length > 2) {
            this.generateLegend();
        } else {
            setTimeout(() => {
                this.checkGenerateLegend();
            },
                1000);
        }
    }

    public async generateLegend(): Promise<void> {
        this.clearLayerList();
        let tempArray = [];
        (this._2dMap.layers as any).items.forEach(f => {
            tempArray.push({ "id": f.id, "title": f.title, "visible": f.visible, "enabled": (f.minScale === 0 || f.minScale > this.mapView.scale) });
        });

        // Sort alpha by title
        tempArray.sort((a, b) => {
            return (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0);
        });

        this.updateLayerList(tempArray);
    }

    public toggleLayer(layerId: string): void {
        let tempFeatureLayer = this._2dMap.allLayers.find(l => l.id === layerId);
        if (tempFeatureLayer) {
            tempFeatureLayer.visible = !tempFeatureLayer.visible;
            // Update layer list
            let tempLayers = this.layerList.getValue();
            (tempLayers.find(l => (l as any).id === tempFeatureLayer.id) as any).visible = tempFeatureLayer.visible;
            this.updateLayerList(tempLayers);
        }

    }

    public parsePopupContent(popupContent: any): string {
        let returnString = "";
        for (var propName in popupContent) {
            if (popupContent[propName] !== null && popupContent[propName] !== undefined) {
                returnString += propName + ": " + popupContent[propName] + "<br />";
            }
        }
        return returnString;
    }
}